// ---------------------------------------------------------------------------
// Link de inscrição com código (?c=...).
// Quando alguém abre a página do evento com ?c=CODIGO e a organização liberou
// alguma modalidade para aquele código, guardamos aqui por 12 h. Assim a rota
// /inscricao/:modalidadeId continua abrindo no celular sem o app (o portão do
// app deixa passar só essas modalidades) e o código não se perde na instalação.
// ---------------------------------------------------------------------------

const CHAVE = 'seliga:inscricao_codigo';
const CHAVE_ABERTA = 'seliga:inscricao_codigo_aberta';
const VALIDADE_MS = 12 * 60 * 60 * 1000; // 12 horas

export interface InscricaoCodigo {
  slug: string;
  codigo: string;
  modalidades: number[];
  em: number;
}

// Salva (sobrescrevendo qualquer registro anterior). Ignora dados incompletos.
export function guardarInscricaoCodigo(
  slug: string,
  codigo: string,
  modalidades: number[],
): void {
  try {
    if (!slug || !codigo) return;
    const limpas = (modalidades || []).filter((n) => typeof n === 'number');
    if (limpas.length === 0) return;
    const dado: InscricaoCodigo = { slug, codigo, modalidades: limpas, em: Date.now() };
    localStorage.setItem(CHAVE, JSON.stringify(dado));
  } catch {
    // armazenamento indisponível: ignora
  }
}

// Lê o registro salvo — devolve null se não existir, estiver corrompido ou já
// tiver passado das 12 h.
export function lerInscricaoCodigo(): InscricaoCodigo | null {
  try {
    const bruto = localStorage.getItem(CHAVE);
    if (!bruto) return null;
    const dado = JSON.parse(bruto) as InscricaoCodigo;
    if (!dado || !Array.isArray(dado.modalidades) || typeof dado.em !== 'number') return null;
    if (Date.now() - dado.em > VALIDADE_MS) return null;
    return dado;
  } catch {
    return null;
  }
}

// Essa modalidade foi aberta por um link de código válido (menos de 12 h)?
export function modalidadeLiberadaPorCodigo(modalidadeId: number): boolean {
  const dado = lerInscricaoCodigo();
  if (!dado) return false;
  return dado.modalidades.includes(modalidadeId);
}

// Apaga o código guardado (quando a inscrição já foi enviada).
export function limparInscricaoCodigo(): void {
  try {
    localStorage.removeItem(CHAVE);
  } catch {
    // armazenamento indisponível: ignora
  }
}

// Marca que já abrimos o app direto na página do evento por causa deste código.
// Serve para não redirecionar de novo a cada abertura do app.
function mesmaChave(dado: { slug: string; codigo: string }): string {
  return `${dado.slug}|${dado.codigo}`;
}

export function marcarCodigoAberto(slug: string, codigo: string): void {
  try {
    localStorage.setItem(CHAVE_ABERTA, mesmaChave({ slug, codigo }));
  } catch {
    // ignora
  }
}

export function codigoJaAberto(slug: string, codigo: string): boolean {
  try {
    return localStorage.getItem(CHAVE_ABERTA) === mesmaChave({ slug, codigo });
  } catch {
    return false;
  }
}